import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { AppStateFacade, Setting, } from '@app-state';
import { UiModalComponent } from '@components';
var DeactivateOfflineModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DeactivateOfflineModalComponent, _super);
    function DeactivateOfflineModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._appState = _this._injector.get(AppStateFacade);
        return _this;
    }
    DeactivateOfflineModalComponent.prototype.ngOnInit = function () {
        this.serviceUrl = this._appState.settings.get(Setting.serviceUrl);
    };
    DeactivateOfflineModalComponent.prototype.generate = function () {
        this.customEvent.emit({
            type: 0 /* Generic */,
        });
    };
    DeactivateOfflineModalComponent.prototype.onClose = function () {
        this._dialogRef.close({
            type: 5 /* Failed */,
            data: this.context.data,
        });
    };
    return DeactivateOfflineModalComponent;
}(UiModalComponent));
export { DeactivateOfflineModalComponent };
